import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { MessageCircleOff } from "lucide-react";
import { useSelector } from "react-redux";

import { UICard, UIEmptyState } from "../../../../ui";
import messages from "../../../../../assets/locale/messages";
import CommentItem from "../CommentItem";

import "../_RequirementsComments.scss";

const EMPTY_STATE_CLASS_NAMES = {
  title: "requirements-comments-empty__title",
  description: "requirements-comments-empty__description",
  iconCircle: "requirements-comments-empty__icon-circle",
};

const InternalComments = ({ comments }) => {
  const lang = useSelector((state) => state.locale.lang);
  const { events } = messages[lang];
  const t = events.viewEvents;

  const list = comments ?? [];

  return (
    <Box className="requirements-comments-section">
      <Typography
        component="h2"
        className="requirements-comments-section__heading"
      >
        {t.internalComments}
      </Typography>

      {list.length === 0 ? (
        <UIEmptyState
          title={t.emptyCommentsTitle}
          description={t.emptyCommentsDescription}
          icon={<MessageCircleOff size={40} strokeWidth={1.5} />}
          classNames={EMPTY_STATE_CLASS_NAMES}
        />
      ) : (
        <UICard>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
            {list.map((comment, idx) => (
              <CommentItem key={comment?.id ?? idx} comment={comment} />
            ))}
          </Box>
        </UICard>
      )}
    </Box>
  );
};

InternalComments.propTypes = {
  comments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      author_name: PropTypes.string,
      author_role: PropTypes.string,
      created_at: PropTypes.string,
      body: PropTypes.string,
    }),
  ),
};

InternalComments.defaultProps = {
  comments: [],
};

export default InternalComments;
